import { render, staticRenderFns } from "./AchievementReport.vue?vue&type=template&id=23b94471&scoped=true&"
import script from "./AchievementReport.vue?vue&type=script&lang=ts&"
export * from "./AchievementReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b94471",
  null
  
)

export default component.exports